// extracted by mini-css-extract-plugin
module.exports = {"quote":"projects_quote__Lu35F","link":"projects_link__3OYn2","wrapper":"projects_wrapper__1Lwv8","img":"projects_img__2scN8"};